export const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: 0,
  width: "100%",
  display: "flex",
  flexDirection: "row",
  gap: "8px",
  overflowX: "auto",
  whiteSpace: "nowrap",
  flexShrink: 0,
});

export const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: 2,
  margin: 0,
  minWidth: "75px",
  flexShrink: 0,
  background: isDragging ? "lightgreen" : "grey",
  ...draggableStyle,
});
